import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ConfigureService } from '@app/configure/services/configure.service';
import { TrackingService } from '@app/core/services/tracking.service';

@Component({
	selector: 'cng-step-bar',
	templateUrl: './step-bar.component.html',
	styleUrls: ['./step-bar.component.less'],
})
export class StepBarComponent implements OnInit {
	@Input() show_next: boolean = true;
	@Input() next_text: string = 'Next';
	@Input() next_icon: string = 'icon-arrow-right';
	@Input() next_submitting: boolean = false;
	@Input() next_disabled: boolean = false;
	@Input() current_step_key: string = '';
	@Input() show_back: boolean = true;
	@Input() back_text: string = 'Back';
	@Input() back_url: string = null;
	@Input() show_pagination: boolean = true;

	@Output() jump = new EventEmitter();

	steps: any = this.configure_service.configure_data.steps;
	steps_order: string[] = this.configure_service.configure_data.steps_order;
	latest_step: string = this.configure_service.configure_data.meta.latest_step;

	current_step_index: number = 0;

	constructor(private configure_service: ConfigureService, private tracking_service: TrackingService) {}

	ngOnInit(): void {
		this.current_step_index = this.steps_order.indexOf(this.current_step_key);
	}

	goBack(): void {
		if (this.current_step_index !== 0) {
			this.jump.emit(this.steps_order[this.current_step_index - 1]);
		}
	}

	goNext(): void {
		if (this.current_step_index !== this.steps_order.length - 1) {
			this.jump.emit(this.steps_order[this.current_step_index + 1]);
		} else {
			this.jump.emit('max');
		}
	}

	jumpTo(new_step_key: string): void {
		this.jump.emit(new_step_key);
	}
}
